import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import { Tile } from "../Primitives";
import { useChartColors } from "../../lib/chartColors";
import { formatPeso } from "../../lib/utils";
import { ChartTip } from "./chartBits";

export default function InventoryMixTile({ valuation }) {
  const C = useChartColors();
  const rows = valuation.byCategory.slice(0, 6).map((c, i) => ({ ...c, color: C.chart[i % 5] }));
  return (
    <Tile className="col-span-12 lg:col-span-4" testid="inventory-mix" title="Inventory Mix by Category · ₱ at cost"
          origin={valuation.originProps}>
      <div style={{ height: 190 }}>
        <ResponsiveContainer>
          <PieChart>
            <Pie data={rows} dataKey="value" nameKey="name" innerRadius={52} outerRadius={82} paddingAngle={2} stroke={C.surface} strokeWidth={2} isAnimationActive={false}>
              {rows.map((c, i) => <Cell key={i} fill={c.color} />)}
            </Pie>
            <Tooltip content={<ChartTip formatter={v => formatPeso(v, { compact: true })} />} />
          </PieChart>
        </ResponsiveContainer>
      </div>
      <div className="mt-3 space-y-2">
        {rows.map(c => (
          <div key={c.name} data-testid={`inventory-mix-${c.name}`} className="flex items-center justify-between gap-2 text-xs">
            <span className="flex items-center gap-2 min-w-0">
              <span className="w-2 h-2 rounded-sm shrink-0" style={{ background: c.color }} />
              <span className="truncate">{c.name}</span>
            </span>
            <span className="font-mono-tabular shrink-0">
              {formatPeso(c.value, { compact: true })}
              <span className="text-muted ml-2">{(c.share * 100).toFixed(1)}%</span>
            </span>
          </div>
        ))}
      </div>
    </Tile>
  );
}
